
export const GET_DEPENDENCIES_REQUEST = 'GET_DEPENDENCIES_REQUEST'; //para saber si esta buscando (fetching)
export const GET_DEPENDENCIES_REQUEST_SUCCESS = 'GET_DEPENDENCIES_REQUEST_SUCCESS'; //si los datos llegan correcto, o sea en un 200 201 o 204 
export const GET_DEPENDENCIES_REQUEST_FAILURE = 'GET_DEPENDENCIES_REQUEST_FAILURE'; //si falla el request y devuelve error, ej: 400, 404, 500
export const CLEAR_GET_DEPENDENCIES_REQUEST = 'CLEAR_GET_DEPENDENCIES_REQUEST'; //con esto limpiamos la data del estado global
